import { render } from "./PageHeader.vue?vue&type=template&id=1d96d173"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=1d96d173&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__